(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awards-index"] && !Shopify.designMode) return;
  try {
    
  if (!window.__macaloneysAwardCountBound) {
    window.__macaloneysAwardCountBound = true;

    function readAwards() {
      var nodes = document.querySelectorAll('[data-awards-index]');
      var awards = [];
      var seen = {};
      for (var n = 0; n < nodes.length; n++) {
        var parsed;
        try {
          parsed = JSON.parse((nodes[n].textContent || '').replace(/^\s+|\s+$/g, ''));
        } catch (e) {
          continue;
        }
        if (!parsed || !parsed.length) continue;
        for (var i = 0; i < parsed.length; i++) {
          var row = parsed[i];
          if (!row || typeof row !== 'object' || row.x === 0) continue;
          var key = row.k || String(i);
          if (seen[key]) continue;
          seen[key] = true;
          awards.push(row);
        }
      }
      return awards;
    }

    function hasText(value) {
      return typeof value === 'string' && value.length > 0;
    }

    function contains(haystack, needle) {
      return hasText(haystack) && hasText(needle) && haystack.indexOf(needle) !== -1;
    }

    function matches(award, titleKey, handleKey) {
      if (hasText(award.p) && hasText(titleKey) && award.p === titleKey) return true;
      if (hasText(award.p) && hasText(handleKey) && award.p === handleKey) return true;
      if (contains(award.h, titleKey)) return true;
      if (contains(award.h, handleKey)) return true;
      if (hasText(award.p) && (contains(titleKey, award.p) || contains(handleKey, award.p))) return true;
      if (hasText(award.s) && (contains(titleKey, award.s) || contains(handleKey, award.s))) return true;
      if (
        hasText(award.a) &&
        (contains(titleKey, award.a) ||
          contains(handleKey, award.a) ||
          contains(award.a, titleKey) ||
          contains(award.a, handleKey))
      ) {
        return true;
      }
      if (hasText(award.l) && (contains(titleKey, award.l) || contains(handleKey, award.l))) return true;
      if (
        hasText(award.u) &&
        (contains(titleKey, award.u) || contains(handleKey, award.u) || contains(award.u, handleKey))
      ) {
        return true;
      }
      return false;
    }

    function countFor(awards, titleKey, handleKey) {
      var count = 0;
      var seen = {};
      for (var i = 0; i < awards.length; i++) {
        var award = awards[i];
        var key = award.k || String(i);
        if (seen[key]) continue;
        if (!matches(award, titleKey, handleKey)) continue;
        seen[key] = true;
        count += 1;
      }
      return count;
    }

    function hydrate() {
      var awards = readAwards();
      if (!awards.length) return;
      var hosts = document.querySelectorAll('[data-award-count-host]');
      for (var i = 0; i < hosts.length; i++) {
        var el = hosts[i];
        var count = countFor(
          awards,
          el.getAttribute('data-title-key') || '',
          el.getAttribute('data-handle-key') || ''
        );
        var showZero = el.getAttribute('data-show-zero') === 'true';
        el.setAttribute('data-award-resolved', '1');
        if (count <= 0 && !showZero) {
          el.setAttribute('hidden', '');
          continue;
        }

        var numberEl = el.querySelector('.award-count__number');
        if (!numberEl) {
          numberEl = document.createElement('span');
          numberEl.className = 'award-count__number';
          el.appendChild(numberEl);
        }
        numberEl.textContent = String(count);

        var showLabel = el.getAttribute('data-show-label') !== 'false';
        var labelEl = el.querySelector('.award-count__label');
        if (showLabel) {
          if (!labelEl) {
            labelEl = document.createElement('span');
            labelEl.className = 'award-count__label';
            el.appendChild(labelEl);
          }
          labelEl.textContent = count === 1 ? 'award' : 'awards';
        }

        el.setAttribute('data-award-count', String(count));
        el.removeAttribute('data-award-pending');
        el.removeAttribute('hidden');
      }
    }

    var hydrateTimer;
    function scheduleHydrate() {
      window.clearTimeout(hydrateTimer);
      hydrateTimer = window.setTimeout(hydrate, 50);
    }

    function bindObserver() {
      if (window.__macaloneysAwardCountObserver) return;
      if (typeof MutationObserver !== 'function' || !document.body) return;
      window.__macaloneysAwardCountObserver = true;
      new MutationObserver(scheduleHydrate).observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        hydrate();
        bindObserver();
      });
    } else {
      hydrate();
      bindObserver();
    }
    document.addEventListener('shopify:section:load', scheduleHydrate);
    document.addEventListener('shopify:section:reorder', scheduleHydrate);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const ageGate = document.querySelector('[data-age-gate]');
      const ageGateHeight = ageGate && ageGate.offsetParent !== null ? ageGate.offsetHeight : 0;
      const announcementBar = document.querySelector('.announcement-bar-section');
      const announcementBarHeight = announcementBar && announcementBar.offsetParent !== null ? announcementBar.offsetHeight : 0;
      const headerHeight = this.header.offsetHeight - ageGateHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight + announcementBarHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
